import { render, staticRenderFns } from "./EnRyuryoChart.vue?vue&type=template&id=b9aba56e&scoped=true"
import script from "./EnRyuryoChart.vue?vue&type=script&lang=ts"
export * from "./EnRyuryoChart.vue?vue&type=script&lang=ts"
import style0 from "./EnRyuryoChart.vue?vue&type=style&index=0&id=b9aba56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aba56e",
  null
  
)

export default component.exports